import { AccountDetailData } from "../../data/accountDetailData";
import { CardData } from "../../data/cardData";
import { SMSPacket } from "../../data/smsPacket";
import { ContractData } from "../../data/contractData";
import { RequestParamsModel } from "../../models/statement/requestParamsModel";
import { CardLimit } from "../../data/cardLimits";
import { DepositForecastItemModel } from "../../models/forecast/depositForecastItemModel";
import { clientTime } from "../../utilities/index";
import { Http } from "./http";

/**Запросы к методам получения настроек с сервера */
export class ContractsApi {
  /**
   * Асинхронная функция получения полного списка счетов.
   * @returns Список счетов.
   */
  static async getAllContractsAsync(): Promise<Array<ContractData>> {
    const contractList: Array<ContractData> = [];
    const respData = await Http.get(
      `WebClient/GetContracts?filter=0&clientTime=${clientTime()}&typeSource=0`
    );

    const contracts = respData?.data;
    if (contracts != null) {
      contracts.forEach((contract: any) => {
        contractList.push(new ContractData(contract));
      });
    }

    return contractList;
  }

  /**
   * Асинхронная функция получения данных счёта.
   * @param id ИД счета.
   * @returns Данные счёта.
   */
  static async getContractAsync(id: number): Promise<ContractData> {
    const respData = await Http.get(
      `WebClient/Get?contractId=${id}&clientTime=${clientTime()}&typeSource=0`
    );

    return new ContractData(respData?.data);
  }

  /**
 * Получение данных по respondentName
 * @param params: RequestParamsModel - набор параметров для метода fillList
 */
  static async fillList(params: RequestParamsModel): Promise<any> {
    const respData = await Http.get(
      `WebClient/FillList?take=${params.take}&skip=${params.skip}&sortType=${params.sortType
      }&respondentName=${params.respondentName}&dateBegin=${params.dateBegin}&dateEnd=${params.dateEnd
      } 23:59:59&${params.contractId ? 'contractId=' + params.contractId : 'cardId=' + params.cardId}&clientTime=${clientTime()}&typeSource=0`
    );

    return respData;
  }

  /**
   * Асинхронная функция получения данных карты.
   * @param id ИД карты.
   * @returns Данные карты.
   */
  static async getCardAsync(id: number): Promise<CardData> {
    const respData = await Http.get(
      `WebClient/GetCardData?cardId=${id}&clientTime=${clientTime()}&typeSource=0`
    );

    return new CardData(respData?.data);
  }

  /**
   * Изменение псевдонима счёта.
   * @param contractId ИД счёта в ДБО.
   * @param alias Текст псевдонима.
   */
  static async editContractAliasAsync(
    contractId: number,
    alias: string
  ): Promise<void> {
    await Http.get(
      `WebClient/EditContractAlias?contractId=${contractId}&alias=${alias}&clientTime=${clientTime()}&typeSource=0`
    );
  }

  /**
   * Изменение псевдонима карты.
   * @param cardId ИД карты в ДБО.
   * @param alias Текст псевдонима.
   */
  static async editCardAliasAsync(
    cardId: number,
    alias: string
  ): Promise<void> {
    await Http.get(
      `WebClient/EditCardAlias?cardId=${cardId}&alias=${alias}&clientTime=${clientTime()}&typeSource=0`
    );
  }

  /**
   * Получение реквизитов счёта.
   * @param contractId ИД счёта.
   * @returns реквизиты счёта
   */
  public static async getAccountDetail(
    contractId: number
  ): Promise<AccountDetailData> {
    const respData = await Http.get(
      `Contract/GetBankDetail?contractId=${contractId}&clientTime=${clientTime()}&typeSource=0`
    );
    return new AccountDetailData(respData?.data);
  }

  /**
   * Получение реквизитов счёта.
   * @param contractId ИД счёта.
   * @returns реквизиты счёта
   */
  public static async sendAccountDetail(
    contractId: number,
    phone: string,
    email: string
  ): Promise<void> {
    const respData = await Http.get(
      `Contract/SendMessage?contractId=${contractId}&phone=${phone}&email=${email}&clientTime=${clientTime()}&typeSource=0`
    );
  }

  public static async getCardLimits(cardId: number): Promise<Array<CardLimit>> {
    const CardLimits: Array<CardLimit> = [];
    const respData = await Http.get(`Contract/GetCardLimits?cardId=${cardId}&clientTime=${clientTime()}&typeSource=0`);
    const response = respData.data.Data.InnerData.Data;
    for (const item in response) {
        CardLimits.push(new CardLimit(response[item].Properties));
    }
    return CardLimits;    
  }

  /**
   * Получения пакета смс
   */
  static async getSMSpackets(): Promise<Array<SMSPacket>> {
    const SMSPackets: Array<SMSPacket> = [];
    const respData = await Http.get(
      `Contract/GetSmsPacketList?clientTime=${clientTime()}&typeSource=0`
    );
    if (
      respData.data &&
      respData.data.length > 0 &&
      respData.data !== undefined
    ) {
      respData.data.forEach((item: any) => {
        SMSPackets.push(new SMSPacket(item));
      });
    }
    return SMSPackets;
  }

  static async getDepositForeCast(
    contractId: number
  ): Promise<Array<DepositForecastItemModel>> {
    const foreCast: Array<DepositForecastItemModel> = [];
    const resData = await Http.get(
      `WebClient/GetForecast?contractId=${contractId}&clientTime=${clientTime()}&typeSource=0`
    );

    if (
      resData.data &&
      resData.data.Data &&
      resData.data.Data.InnerData &&
      resData.data.Data.InnerData.Data
    ) {
      for (const key in resData.data.Data.InnerData.Data) {
        const prop = resData.data.Data.InnerData.Data[key].Properties;
        foreCast.push(new DepositForecastItemModel(prop));
      }
    }
    return foreCast;
  }

  static async getCardRest(cardId: number): Promise<any> {
    const responseData: any = await Http.get(`Contract/GetCardLimits?cardId=${cardId}&clientTime=${clientTime()}`);
    let result: any = null;

    if (responseData.result === 'ok') {
      result = responseData.data.Data.InnerData.Data;
    }

    return result;
  }
}
